var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.mode == "edit"
        ? _c("el-input-number", {
            ref: _vm.reference,
            attrs: {
              min: parseInt(_vm.prop.min),
              max: parseInt(_vm.prop.max),
              controls: false
            },
            model: {
              value: _vm.localValue.numericValue,
              callback: function($$v) {
                _vm.$set(_vm.localValue, "numericValue", $$v)
              },
              expression: "localValue.numericValue"
            }
          })
        : _c("p", [
            _vm._v("\n        " + _vm._s(_vm.numericDisplay) + "\n    ")
          ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }